module.exports = __webpack_public_path__ + "img/19.68b02436.webp";